import { QuestionCircleOutlined } from '@ant-design/icons';
import { Button, Grid, theme } from 'antd';
import React from 'react';

export default function DocumentationButton() {
  const { token } = theme.useToken();
  const breakpoints = Grid.useBreakpoint();

  return (
    <Button
      type="link"
      href="https://docs.decafhub.com"
      target="_blank"
      rel="noreferrer"
      icon={<QuestionCircleOutlined />}
      style={{ backgroundColor: token.colorBgElevated }}
    >
      {!breakpoints.xs && 'Documentation'}
    </Button>
  );
}
